<ion-content class="ion-padding">
  <div class="container max-w-3xl">
    <h1 class="text-2xl font-extrabold mb-4 dark:text-slate-100">Informativa sui cookie</h1>

    <p class="mb-4">Ultimo aggiornamento: {{ lastUpdated }}</p>

    <section class="mb-4">
      <h2 class="font-semibold dark:text-slate-100">Uso dei cookie</h2>
      <p>
        Questo sito web è gestito da {{ siteOwner }}. Al momento il sito non utilizza cookie di profilazione né strumenti di terze parti che installano cookie per finalità pubblicitarie.
        Il sito utilizza solo il <strong>localStorage</strong> del browser per memorizzare preferenze locali (ad esempio tema scuro/chiaro e lingua). Il localStorage non è un cookie e non viene inviato ai server.
      </p>
    </section>

    <section class="mb-4">
      <h2 class="font-semibold dark:text-slate-100">Cosa sono i cookie</h2>
      <p>
        I cookie sono piccoli file di testo inviati al tuo browser da un sito web che stai visitando. Possono servire per rendere il sito più efficiente o per fornire informazioni ai proprietari del sito.
      </p>
    </section>

    <section class="mb-4">
      <h2 class="font-semibold dark:text-slate-100">Tipologie di cookie</h2>
      <ul class="list-disc ml-5">
        <li><strong>Cookie tecnici</strong>: necessari per il funzionamento del sito (es. gestione sessione). In genere non richiedono consenso.</li>
        <li><strong>Cookie di preferenza</strong>: memorizzano le scelte dell'utente (es. lingua, tema).</li>
        <li><strong>Cookie di terze parti</strong>: installati da servizi esterni (es. analytics, social). Al momento non sono presenti.</li>
      </ul>
    </section>

    <section class="mb-4">
      <h2 class="font-semibold dark:text-slate-100">Consenso e gestione</h2>
      <p>
        Poiché non sono utilizzati cookie di profilazione o di terze parti, non è richiesta una procedura di raccolta consenso per i cookie di base. Se in futuro verranno aggiunti strumenti di analisi o advertising, verrà mostrata una richiesta di consenso conforme al GDPR e alle linee guida italiane.
      </p>
      <p class="mt-2">
        Puoi comunque gestire e disabilitare i cookie direttamente dal tuo browser. Per istruzioni: usa le impostazioni del browser (Chrome, Firefox, Edge, Safari) per rimuovere o bloccare i cookie.
      </p>
    </section>

    <section class="mb-4">
      <h2 class="font-semibold dark:text-slate-100">Contatti</h2>
      <p>Per domande relative alla presente informativa, contatta: <a href="mailto:alessandro.bompadre@gmail.com">alessandro.bompadre@gmail.com</a></p>
    </section>
  </div>
</ion-content>
